if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(129|243|573|751|76)|2(023|29|354|390|565)|3(634|700|907)|5(151|36|774|971)|6(088|111|135|579|717|801)|8(2(54|56|7)|469|564|654|735|795|997)|9(019|121|135|318|630)|4101|4249|715|7827)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}